var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{style:({'background-color': _vm.background, 'padding': _vm.padding})},[_c('v-container',{style:({'max-width': _vm.maxWidth})},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }